export const retry = async (fn: () => Promise<any>, n: number = 3) => {
  for (let i = 0; i < n; i++) {
    try {
      return await fn();
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
  }

  throw new Error(`Failed retrying ${n} times`);
};

export const getData = async (url: string, token: string, signal?: AbortSignal, queryParams?: URLSearchParams) => {
  let fullUrl;
  if (queryParams){
    fullUrl = new URL(url);
    fullUrl.search = queryParams?.toString();
  }
  const response = await fetch(fullUrl ?? url, {
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
      'requestverificationtoken': token,
    },
    redirect: 'follow',
    signal,
  });

  if (response.ok) {
    return await response.json();
  }

  throw new Error('Request failed.');
};

export const postData = async (url: string, body: any = {}, token: string, signal?: AbortSignal) => {
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
      'requestverificationtoken': token,
    },
    redirect: 'follow',
    signal,
  });

  if (response.ok) {
    return response;
  }

  if (response.status === 409) {
    return response;
  }

  throw new Error('Request failed.');
};
